import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../layoutPages/components/PageTitle';
import { HaveImage, Paragraph } from '../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../layoutPages/defaultSetting';
import { DottedList } from '../../layoutPages/containers/DottedList';
import { MainCard } from '../../layoutPages/components/MainCard';
import ChangeHistoryTwoToneIcon from '@mui/icons-material/ChangeHistoryTwoTone';
import StarsIcon from '@mui/icons-material/Stars';
import WebIcon from '@mui/icons-material/Web';
import { mathMenuData } from '../../data/SubjectMenu/mathMenuData';
import { MainCards } from '../../layoutPages/containers/MainCards';
import { MaterialList, MaterialWithLink } from '../../layoutPages/components/MaterialList';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export function other_report() {

    const data: Array<MaterialWithLink> = [
        
        { name: "支援開設小學科學科一筆過津貼計劃(2025-2026)",  src: "https://www.pkps.edu.hk/pdf/report/other_report/science2526.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "支援學校推動校園體育氛圍津貼計劃(2025-2026)",  src: "https://www.pkps.edu.hk/pdf/report/other_report/enhance2526.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "家長教育津貼運用計劃(2025-2026)", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/2526par_plan.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "家長教育津貼運用報告(2024-2025)", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/2425par_report.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "推廣中華文化體驗活動一筆過津貼計劃(2025-2026)", src: "https://www.pkps.edu.hk/pdf/report/other_report/culture2526.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },

    ]

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title='計劃/報告 | 各類一次性津貼計劃' size='h3' />
    
            <Grid item xs={11} sm={10} sx={{ p: 2 }}>
               
                <Paragraph title="" sx={{ mt: 2 }}
                    instantAppear
                    data={[
                        <MaterialList data={data} />]}
                />

            </Grid>

        </Grid>
    )
}